import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import App from './App';
import { ErrorBoundary } from './components/layout/ErrorBoundary';
import './globals.css';
import { TITLE_PREFIX } from './lib/routing/documentTitle';
// F3: registers window.__feedLatency() / window.__pushLatency() (the
// feed→screen and relay-push probes). Side-effect import only — the stamps
// live in marketStore / relayPush; nothing is spent until a live view
// registers tickers.
import './lib/trading/feedLatencyProbe';

// speed-demon T-A3: the default Resource Timing ring (250 entries) overflows
// in minutes under the feed's fetch churn, evicting the order POST entries the
// latency probe cross-references. Widen it at boot; feature-detected so a
// non-supporting runtime is a no-op.
if (
  typeof performance !== 'undefined' &&
  typeof performance.setResourceTimingBufferSize === 'function'
) {
  performance.setResourceTimingBufferSize(500);
}

// Login/bootstrap renders before the authenticated shell owns the route title.
document.title = TITLE_PREFIX;

const root = ReactDOM.createRoot(document.getElementById('root')!);
const tree = (
  <React.StrictMode>
    <ErrorBoundary>
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// #1150 — dev-only Novig fixture seam: `VITE_NOVIG_FIXTURES=1` in .env.local
// wraps the app in a gitignored local provider (src/lib/dev). The glob matches
// nothing on a clone without that file, and production never takes this branch.
if (import.meta.env.DEV && import.meta.env.VITE_NOVIG_FIXTURES === '1') {
  const [load] = Object.values(import.meta.glob<{ wrapNovigFixtures(app: React.ReactNode): React.ReactNode }>(
    './lib/dev/novigFixtures.local.ts'));
  void (load ? load().then((m) => m.wrapNovigFixtures(tree)) : Promise.resolve(tree)).then((app) => root.render(app));
} else {
  root.render(tree);
}
